import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { OnbFormDialogContentWrapper } from './components/onbFormDialogContentWrapper/OnbFormDialogContentWrapper'

interface IOnbPartnerFormDialogProps {
  show: boolean
  onClose: () => void
  partnerId: string
  appSource: string
}

export const OnbPartnerFormDialog = ({
  show,
  partnerId,
  onClose,
  appSource,
}: IOnbPartnerFormDialogProps) => {
  const contentProps = useMemo(() => ({ partnerId, appSource }), [appSource, partnerId])
  return (
    <ModalDialog
      show={show}
      onClose={onClose}
      content={OnbFormDialogContentWrapper}
      contentProps={contentProps}
    />
  )
}
